import React from "react";

import qrCode from "../../resources/school/qrCode.jpg";
import doubleDown from "../../resources/assets/Double Down.png";
import Row from "../common/Row";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("common");

  return (
    <div>
      <div className="bg-gray-100 p-10 space-y-8">
        <img
          className="mx-auto"
          src={doubleDown}
          alt="img not found"
          style={{ width: "50px" }}
        />
        <div className="flex justify-center">
          <span className="bg-emerald-600 text-center text-white p-4">
            {t("footer.banner")}
          </span>
        </div>
      </div>

      <div className="footer bg-green-800 text-white py-10">
        <Row spaceClass="md:space-x-32 space-y-16">
          <div className="space-y-4 text-left">
            <div className="text-2xl font-bold">{t("footer.contactTitle")}</div>
            <div className="border-t-8 rounded-full border-white/50 w-1/5"></div>
            <div>
              {t("footer.emailLabel")}
              <br />
              <a
                href="mailto:support@gechineseschool.com"
                className="hover:underline"
              >
                support@gechineseschool.com
              </a>
              <br />
              <br />
              {t("footer.campusName")}
              <br />
              {t("footer.addressLabel")}11431 NE 20th St, Bellevue, WA 98004
              <br />
              {t("footer.phoneLabel")}888-684-7070
            </div>
          </div>

          <div className="space-y-4 text-left">
            <div className="text-2xl font-bold">{t("footer.followTitle")}</div>
            <div className="border-t-8 rounded-full border-white/50 w-1/3"></div>
            <img
              src={qrCode}
              alt="QR Code"
              className="mt-2"
              style={{ width: "100px" }}
            />
            <div>
              {t("footer.scan")}
              <br />
              {t("footer.officialAccount")}
              <br />
            </div>
          </div>
        </Row>

        <div className="mt-4 py-4 flex justify-center">
          <div className="border-t-2 border-white/50 w-2/3 mx-auto"></div>
        </div>

        <p className="text-center text-xs">
          © 2019-2025 by Ge Chinese School LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;